import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import {
    ContextLayersDisplayModeEnum,
    FieldInterventionContextLayersComponent,
} from '@connect-services/client/components/field-intervention-context-layers/field-intervention-context-layers.component';
import { ModalResultEnum } from '@connect-services/client/models/common.model';
import { FieldInterventionContextLayerOption } from '@connect-services/client/services/field-intervention.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

export type EditFieldInterventionContextLayersModalData = Readonly<{
    options: FieldInterventionContextLayerOption[];
    selectedOptions: FieldInterventionContextLayerOption[];
}>;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, FieldInterventionContextLayersComponent, RessourcesModule],
    selector: 'app-edit-field-intervention-context-layers-modal',
    templateUrl: './edit-field-intervention-context-layers-modal.component.html',
})
export class EditFieldInterventionContextLayersModalComponent {
    public readonly data: EditFieldInterventionContextLayersModalData = inject(MAT_DIALOG_DATA);

    protected readonly FieldInterventionContextLayersDisplayModeEnum = ContextLayersDisplayModeEnum;
    protected readonly selectedOptions: WritableSignal<FieldInterventionContextLayerOption[]> = signal(
        this.data.selectedOptions,
    );

    private readonly dialogRef = inject(MatDialogRef<EditFieldInterventionContextLayersModalComponent>);

    protected cancel(): void {
        this.dialogRef.close(null);
    }

    protected confirm(): void {
        this.dialogRef.close(this.selectedOptions());
    }

    protected onModalResult(result: ModalResultEnum): void {
        if (result === ModalResultEnum.CANCEL) {
            this.cancel();

            return;
        }

        this.confirm();
    }

    protected onSelectionChange(selectedValues: string[]): void {
        const selectedOptions = this.data.options.filter((option: FieldInterventionContextLayerOption) =>
            selectedValues.includes(option.value),
        );

        this.selectedOptions.set(selectedOptions);
    }
}
